import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#65C3FF' cx='12' cy='12' r='12' />,
    <circle key='1' fill='#65C3FF' cx='12' cy='12' r='10' />,
    <path
      key='2'
      fill='#FFFFFF'
      d='M9,12.6V9H7.2V6.3h2.1c0.6-1,2.2-1.2,4.1-1.2c0.4,0,0.7,0,1,0c-0.7-0.8-2.2-1-3.9-1C8,4.1,6.1,4.4,6.1,6.3v5.4
        c0,0.5,0.2,0.9,0.5,1.2v1c0,0.3,0.2,0.5,0.5,0.5h0.5c0.3,0,0.5-0.2,0.5-0.5v-0.5H9C9.1,13.1,9,12.9,9,12.6z M8,12.2
        c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.5,12.2,8,12.2z'
    />,
    <path
      key='3'
      fill='#FFFFFF'
      d='M10,13.6c0,0.5,0.2,0.9,0.5,1.2v1c0,0.3,0.2,0.5,0.5,0.5h0.5c0.3,0,0.5-0.2,0.5-0.5v-0.5h4.3v0.5c0,0.3,0.2,0.5,0.5,0.5h0.5
        c0.3,0,0.5-0.2,0.5-0.5v-1c0.3-0.3,0.5-0.7,0.5-1.2V8.2C18.3,6.3,16.4,6,14,6s-4,0.4-4,2.2V13.6z M11.9,14.2c-0.4,0-0.8-0.4-0.8-0.8
        s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8S12.4,14.2,11.9,14.2z M16.8,14.2c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8
        S17.2,14.2,16.8,14.2z M17.6,10.9h-6.5V8.2h6.5V10.9z'
    />,
    <path
      key='4'
      fill='#FFFFFF'
      d='M17.7,19.3h-6.8c-0.5,0-1-0.4-1-1l0,0c0-0.5,0.4-1,1-1h6.8c0.5,0,1,0.4,1,1l0,0C18.7,18.8,18.2,19.3,17.7,19.3z'
    />,
  ],
  'TransportConditionGeofenceQueue'
);

const TransportConditionGeofenceQueueIcon = function (props) {
  return <SvgIcon xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' {...props} />;
};

export default memo(TransportConditionGeofenceQueueIcon);
